/* eslint no-template-curly-in-string: 0 */

import { PAYMENT_STATUSES } from "../../../../utils/enums";

export const bestBuy = {
  paywall: {
    tile: {
      displayName: ["Best Buy eGiftCard™"],
      tagline: "Úsela en línea o en la tienda",
      description: [
        {
          string: "Fondos inmediatos para comprar electrónica y entretenimiento.",
          type: "div",
        },
      ],
    }
  },
  recipientLogin: {
    loading: {
      title: "Preparando su Best Buy eGiftCard™"
    }
  },
  acceptPayment: {
    btnLabel: "Aplicar a ${paymentNetwork.displayName}",
    description: [
      "Ha elegido recibir una Best Buy eGiftCard™ de ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " que será enviado por correo electrónico a ",
      {
        string: "${payment.recipientEmail}.",
        props: {
          className: 'payment-recipientEmail'
        }
      },
      "."
    ],
  },
  paymentComplete: {
    initial: {
      title: "¡Pago exitoso!",
      description: [
        "¡Éxito! Por favor, revise su correo electrónico ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " para obtener más información con respecto a su ",
        {
          string: "Best Buy eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ". Debería llegarle pronto e incluirá los detalles para su uso."
      ],
      secondaryText: "Por favor, considere esta tarjeta como si fuese dinero en efectivo y tenga el debido cuidado para evitar la pérdida o robo.",
    },
    revisit: {
      description: [
        "El ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt',
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        ", un correo electrónico fue enviado a ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " con los detalles relacionados con su ",
        {
          string: "Best Buy eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        "."
      ],
      secondaryText: "Por favor, considere esta tarjeta como si fuese dinero en efectivo y tenga el debido cuidado para evitar la pérdida o robo.",
    },
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        {
          answer: "Las tarjetas de regalo Best Buy® facilitan poder disfrutar de la última tecnología. Tanto si busca dispositivos inteligentes para el hogar, aviones teledirigidos o televisores 4K Ultra HD, Associates le ayudará a tomar la decisión correcta. Además, Geek Squad® puede ayudarle a que todo funcione correctamente con la instalación, configuración, asistencia y reparación. Utilice las tarjetas de regalo Best Buy para obtener la tecnología que desea y los servicios que necesita en las tiendas y en <a href=\"BestBuy.com\">BestBuy.com®</a>.<br/><br/>Para conocer los términos y condiciones completos de la tarjeta de regalo Best Buy, visite <a href=\"www.bestbuy.com/gcterms\">www.bestbuy.com/gcterms</a>.",
          question: "Acerca de la tarjeta electrónica de regalo de BestBuy®"
        }
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        {
          answer: "Las tarjetas de regalo Best Buy® facilitan poder disfrutar de la última tecnología. Tanto si busca dispositivos inteligentes para el hogar, aviones teledirigidos o televisores 4K Ultra HD, Associates le ayudará a tomar la decisión correcta. Además, Geek Squad® puede ayudarle a que todo funcione correctamente con la instalación, configuración, asistencia y reparación. Utilice las tarjetas de regalo Best Buy para obtener la tecnología que desea y los servicios que necesita en las tiendas y en <a href=\"BestBuy.com\">BestBuy.com®</a>.<br/><br/>Para conocer los términos y condiciones completos de la tarjeta de regalo Best Buy, visite <a href=\"www.bestbuy.com/gcterms\">www.bestbuy.com/gcterms</a>.",
          question: "Acerca de la tarjeta electrónica de regalo de BestBuy®"
        }
      ]
    }
  },
};

export default bestBuy;
